module.exports = __webpack_public_path__ + "media/images/przedszkole9-32b39a481f9847f5778058e46767c7c0.png";